import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { RecaptchaModule } from 'ng-recaptcha';
import { RecaptchaFormsModule } from 'ng-recaptcha/forms';
import { GridModule } from '@progress/kendo-angular-grid';
import { SharedModule } from '@app/shared/shared.module';
import { CanDeactivateGuard } from '@app/base/shared';
import { MatProgressSpinnerModule} from '@angular/material/progress-spinner';
import { AppNotFoundComponent } from '@app/base/errors';
import {MatCardModule} from '@angular/material/card';
import { MatTooltipModule } from '@angular/material/tooltip';
import {
  LandingService,
  LandingComponent,
  CompanyComponent,
  HomeComponent,
  StatusComponent,
  LetterComponent,
} from '@app/modules/landing';
import { BuilderRegisterComponent } from '../components/builder-register/builder-register.component';
import { ServiceTrackerComponent } from '../components/service-tracker/service-tracker.component';
import { MatStepperModule } from '@angular/material/stepper';
import { MatIconModule } from '@angular/material/icon';
import { CapitalizeFirstLetterPipe } from '../components/service-tracker/capitalize-first-letter.pipe';

 export const routes: Routes = [
  {
    path: '',
    component: LandingComponent,
    children: [
      { path: '', pathMatch: 'full', redirectTo: 'home', data: { title: 'Applicant Request | Home Page' } },
      { path: 'serviceTracker', component: ServiceTrackerComponent, data: { title: 'Applicant Request | serviceTracker' } },
      { path: 'company', component: CompanyComponent, data: { title: 'Applicant Request | Select Company' } },
      { path: 'register', component: BuilderRegisterComponent, data: { title: 'Applicant Request | Select Company' } },
      { path: 'home', component: HomeComponent, data: { title: 'Applicant Request | Home Page' }},
      { path: 'status/:id', component: StatusComponent, data: { title: 'Applicant Request | Status' } },
      { path: 'status', component: StatusComponent, data: { title: 'Applicant Request | Status' } },
      { path: 'letter', component: LetterComponent,  canDeactivate: [CanDeactivateGuard], data:
       { title: 'Applicant Request | Gas Availability Letter' } },
      { path: '**', component: AppNotFoundComponent, data: { title: 'Applicant Request | Error' } },
    ]
  }
];

@NgModule({
  imports: [
    SharedModule,
    RouterModule.forChild(routes),
    RecaptchaModule.forRoot(),
    RecaptchaFormsModule,
    GridModule,
    MatCardModule,
    MatStepperModule,
    MatIconModule,
    MatProgressSpinnerModule,
    MatTooltipModule
  ],
  declarations: [
    LandingComponent,
    CompanyComponent,
    HomeComponent,
    StatusComponent,
    LetterComponent,
    BuilderRegisterComponent,
    ServiceTrackerComponent,
    CapitalizeFirstLetterPipe
  ],
  providers: [LandingService, CanDeactivateGuard,CapitalizeFirstLetterPipe]
})
export class LandingModule { }
